import React, {Component} from 'react';
import axios from 'axios';
import config from "../../../config";
import i18n from "../../../i18n";
import SearchView from "../views/SearchView";
import {FormUtility, withError} from "cw-styleguide-react";
import validate from "validate.js";
import constraints from "../../../constraints";
import {route} from "../../../routes";

class SearchController extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      filterValues: {
        courseId:"",
        courseTitle:"",
        keyword:"",
        location:"",
        proximity: "5",
        qualificationType: new Set(),
        studyMethodType: new Set(),
        studyMethodHours: new Set(),
        studyMethodTimes: new Set(),
        programme: new Set(),
        courseType: new Set(),
        provider:"",
      },
      settingsLoaded: false,
      formErrors:[],
      reloadKey: Math.random()
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    axios.get(config.endpoints.courseSearchSettings[i18n.language], {
      params: {
        time: Date.now()
      }
    })
    .then(response => {
      this.setState({
        content: response.data.content,
        settingsLoaded:true
      });
    })
    .catch(error => {
      let errors = FormUtility.processServerErrors(error, i18n);
      this.setState({
        formErrors: errors.formErrors,
        messages: errors.messages,
        settingsLoaded: false
      })
    });

    this.props.resetQuery();
    this.props.styleguide.setLanguageUrl(route('courseSearch',null,this.props.i18n.language === 'cy' ? 'en' : 'cy') );
  }


  /**
   * handleSubmit
   * @param e
   */
  handleSubmit(e) {
    e.preventDefault();

    const formErrors = validate(this.state.filterValues, constraints(), {fullMessages: false, format: 'flat'});

    if (formErrors) {
      this.setState({
        formErrors: formErrors
      });
    }
    else {

      if (this.state.filterValues.location) {
        this.state.filterValues.order = 'locationAsc';
      }

      const parameters = this.props.convertFiltersToParameters(this.state.filterValues);



      this.props.navigate(route('results') + parameters);
    }
  }

  /**
   * handleChange
   * @param event
   */
  handleChange(event) {
    const values = {...this.state.filterValues};
    this.setState({
      filterValues: FormUtility.setFormValues(event, values)
    });
  }

  render() {
    return <SearchView {...this.props} {...this.state} handleChange={this.handleChange} handleSubmit={this.handleSubmit}/>;
  }
}

export default withError(SearchController);
